<script>
	import { Scatter } from 'vue-chartjs'

        export default {
            extends: Scatter,
            data () {
                let beforeLabel = this.labelBeforeValue;
                let afterLabel  = this.labelAfterValue;
                return {
                    chart_options: {
	                    scales: {
	                        yAxes: [{
	                            ticks: {
                                    beginAtZero: true,
                                    callback: function(value, index, values) {
                                        return beforeLabel + value + afterLabel;
                                    }
	                            }
	                        }]
	                    },
                        responsive: true,
                        maintainAspectRatio: false
                    },
                    datas: {}
                }
            },
            mounted () {
                 this.addPlugin({
                        id: 'scatterDataLabels',
                        afterDatasetsDraw: function(chart, args, options){

                            const { ctx } = chart;
                            ctx.save();
                            ctx.font = '12px sans-serif';

                            for (let x = 0; x < chart.config.data.datasets.length; x++){
                                for (let i = 0; i < chart.config.data.datasets[x].data.length; i++){

                                    if (chart.isDatasetVisible(x) === true){
                                        ctx.fillStyle = '#666';
                                    } else {
                                        ctx.fillStyle = 'transparent';
                                    }

                                    if (chart.config.data.datasets[x].data[i].label != null){
                                        const textWidth = ctx.measureText(chart.config.data.datasets[x].data[i].label).width;
                                        var cx = chart.getDatasetMeta(x).data[i]._view.x;
                                        var cy = chart.getDatasetMeta(x).data[i]._view.y;                                    
                                        ctx.fillText(chart.config.data.datasets[x].data[i].label, cx - textWidth, cy - 10);
                                    }                                    
                                }   
                            }
                            ctx.restore();                                                        
                        }
                    });
	            this.fetchDatas();
	            // Overwriting base render method with actual data.
            },
        methods: {

            changeUrl(newUrl) {
                this.url = newUrl;
                this.fetchDatas();
            },

            fetchDatas() {
                
                var url = this.url;
                if (this.stringParameters != null && this.stringParameters != ""){
                    url += "?" + this.stringParameters;
                }
                
	            axios.get(url).then(response => {                    
            		this.datas = response.data;
                    if (response.data.config != null){                        
                        this.renderChart(this.datas, response.data.config);
                    } else {
                        this.renderChart(this.datas, this.chart_options);
                    }            		
            	});
            }
        },
        props: {
            url:{
	            type: String,
	            required: true
            },
            stringParameters:{
                type: String,
                required: false
            },
            labelBeforeValue: {
	            type: String,
	            required: false,
	            default : ""
            },
            labelAfterValue: {
	            type: String,
	            required: false,
	            default : ""
            }
        }

    }
</script>
